import { api } from "../../../api/api";
import { IMarketCampaignQuickSendList } from "../../../redux/marketCampaign/marketCampaign.types";
import { ISearchQueryParams } from "../../../redux/store.types";
import { getSearchQueryParams } from "../../../redux/store.utils";


export const fetchAllMarketCampaignAudienceListAsync = async (queryParams: ISearchQueryParams) => {
    try {
        const { signal } = queryParams;

        const searchQuery = getSearchQueryParams(queryParams);
        const res = await api.get(`/campaign/get-market-campaign-audience-list`, {
            params: searchQuery,
            signal
        });

        return {
            data: res.data.data,
            totalRecords:
                res.data.totalRecords ??
                res.data.total_records ??
                res.data.total ??
                0,
        };
    } catch (err: any) {

    }
}


export const fetchUniqueMarketCampaignQuickSendListAsync = async (company_outlet_uuid: string, market_campaign_uuid: string): Promise<IMarketCampaignQuickSendList | null> => {
    try {
        const res = await api.get(`/campaign/get-quick-send-campaign-list`, {
            params: {
                company_outlet_uuid,
                market_campaign_uuid
            }
        });
        return res.data?.data?.[0] ?? null;
    } catch (error) {
        throw error;
    }
}